import { useEffect, useState } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from 'moment';
import { Edit, PlusCircle, Trash } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import { useDeleteTicketCategory, useTicketCategories, useUpdateCategoryStatus } from '../api/supportapi';
import { NoRecords, PageLoader } from '../../../lib/loader';
import { useDebounce } from '../../../hooks/debounce';
import useConfirm from '../../../hooks/useConfirm';
import { Modal, ModalBody } from 'reactstrap';
import closecirImg from '../../../assets/images/icons/close-circle.svg'
import EditCategory from './EditTicketCategory';
import BreadcrumbPagination from '../../../utils/BreadcrumbPagination';
import { useBreadcrumbPagination } from '../../../hooks/useBreadcrumbPagination';

function TicketCategory() {

    const navigate = useNavigate();
    const [tempPage, setTempPage] = useState(0);
    const [tempRows, setTempRows] = useState(25);
    const [sortOrder] = useState("desc")
    const searchText = useDebounce("");
    const [Dialog, confirmDelete] = useConfirm()
    const updateCategoryStatus = useUpdateCategoryStatus()

    const { data: getcategories, isLoading } = useTicketCategories({
        page: tempPage,
        size: tempRows,
        searchText,
        sortField: "_id",
        sortOrder: sortOrder
    })

    const totalRecords = getcategories?.data?.count || 0;

    const {
        page,
        rowsPerPage,
        totalPages,
        handleChangePage,
        handleChangeRowsPerPage
    } = useBreadcrumbPagination(totalRecords, tempRows);

    useEffect(() => {
        setTempPage(page);
    }, [page]);

    useEffect(() => {
        setTempRows(rowsPerPage);
    }, [rowsPerPage]);



    const Addcategory = () => {
        navigate(`/addticket-category`);
    }

    const deleteCatMutation = useDeleteTicketCategory()
    const deleteCategory = async (item) => {
        const isConfirmed = await confirmDelete()
        if (isConfirmed) {
            await deleteCatMutation.mutateAsync(item);
        }
    }

    const query = new URLSearchParams(window.location.search);
    const id = query.get('id');

    const [openedit, setOpenedit] = useState(false)
    const toggleEdit = () => setOpenedit(!openedit)

    const handleEdit = (id) => {
        navigate(`?id=${id}`)
        toggleEdit();
    }

    const categoryStatus = async (item) => {
        const obj = {
            name: item.name,
            status: !item.status,
            _id: item._id
        }
        await updateCategoryStatus.mutateAsync({ ...obj });
    }

    const renderAddcategoryTable = () => (
        getcategories?.data?.data?.length > 0 ?
            <>
                <div style={{ minHeight: "60vh" }}>
                    <div className='table-responsive'>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ maxWidth: "60px" }} align='center'>
                                        S.NO
                                    </TableCell>
                                    <TableCell >Category Name</TableCell>
                                    <TableCell >Date and Time</TableCell>
                                    <TableCell >Status</TableCell>
                                    <TableCell align='center' >Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {getcategories?.data?.data?.map((row, i) => (
                                    <TableRow key={row._id || i}>
                                        <TableCell align='center'>{page * rowsPerPage + (i + 1)}</TableCell>
                                        <TableCell >{row.name}</TableCell>
                                        <TableCell >
                                            {moment(row.createdAt).format("DD-MM-YYYY | hh:mm A")}
                                        </TableCell>
                                        <TableCell>
                                            <div className="form-check form-switch">
                                                <input className="form-check-input"
                                                    type="checkbox"
                                                    role="switch" id="flexSwitchCheckDefault"
                                                    checked={row.status}
                                                    onClick={() => categoryStatus(row)} />
                                            </div>
                                        </TableCell>
                                        <TableCell align='center' >
                                            <div className='d-flex justify-content-center'>
                                                <Edit className="mx-3" size={20} type='button' onClick={() => handleEdit(row._id)} />
                                                <Trash className="mx-3" size={20} onClick={() => deleteCategory(row)} type='button' />
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <BreadcrumbPagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    totalPages={totalPages}
                    totalRecords={totalRecords}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </>
            :
            <NoRecords />
    )

    return (
        <section>
            <h3>Ticket Category</h3>
            <div className="ad_pg_bx bg-white p-3">
                <div className='d-flex justify-content-end align-items-center mb-2'>
                    <button className='btn btn-primary d-flex align-items-center' onClick={() => Addcategory()}>
                        <PlusCircle size={20} style={{ marginRight: "2px" }} /> Add category
                    </button>
                </div>
                {isLoading ?
                    <PageLoader />
                    :
                    renderAddcategoryTable()
                }
            </div>
            <Dialog />
            <Modal isOpen={openedit} toggle={toggleEdit} centered>
                <div className="modal-header">
                    <h1 className="modal-title fs-5">Edit Category</h1>
                    <button type="button" className="btn-close" onClick={toggleEdit} aria-label="Close">
                        <img src={closecirImg} alt="close-circle" />
                    </button>
                </div>
                <ModalBody>
                    <EditCategory toggle={toggleEdit} editData={id} />
                </ModalBody>
            </Modal>

        </section >
    )

}

export default TicketCategory